import { FundOverviewSectionSchema } from "@/FundExplorer/components/Display/FundOverview/types";
import { parseHTMLFragment } from "@/lib";
import parseHtmlFragment from "@/lib/extractJSON";
import parseEncodedJSON from "@/lib/parseEncodedJSON";
import {
	BaseSRPSectionConfigSchema,
	ShareClassesAPIResponseSchema,
} from "@/types";
import { SRP } from "hsl-core/providers";

export default function useOverviewTabData(config: string, fundId?: number) {
	const parsedConfig = BaseSRPSectionConfigSchema.safeParse(
		parseEncodedJSON(config),
	);
	const { data: shareClassesData } = SRP.usePart(
		parsedConfig.success && !!parsedConfig.data.shareClassesPartId && !!fundId,
		{
			id: parsedConfig.success ? parsedConfig.data.shareClassesPartId : 0,
			fund_id: fundId,
		},
	);
	const shareClasses = ShareClassesAPIResponseSchema.safeParse(
		parseHtmlFragment(shareClassesData as string),
	);
	const canLoadTabData =
		parsedConfig.success && shareClasses.success && !!parsedConfig.data.partId;
	const { data, isLoading, isError, isPending } = SRP.usePart(canLoadTabData, {
		id: parsedConfig.success ? parsedConfig.data.partId : 0,
		fund_id: fundId,
		share_class_id: shareClasses.success
			? shareClasses.data.data.shareClasses[0].id
			: undefined,
	});
	const parsedTabData = parseHTMLFragment(data as string);
	const validatedTabData = FundOverviewSectionSchema.safeParse(parsedTabData);
	if (!validatedTabData.success && !isLoading && !isPending) {
		console.log(validatedTabData.error);
	}

	return {
		data: validatedTabData.success ? validatedTabData.data : null,
		shareClasses: shareClasses.success
			? shareClasses.data.data.shareClasses
			: [],
		isLoading,
		isError,
	};
}
